__turbopack_context__.v({
  "active": "cVrthW_active",
  "list_title": "cVrthW_list_title",
  "mid_divider": "cVrthW_mid_divider",
  "sidebar_list": "cVrthW_sidebar_list",
  "topic_list": "cVrthW_topic_list",
});
